import React from 'react';

function FooterMain() {
  const footerSections = [
    {
      title: "For Clients",
      links: [
        { label: "Find Therapists", href: "/find-therapists" },
        { label: "How It Works", href: "/how-it-works" },
        { label: "Insurance", href: "/insurance" },
        { label: "Specialties", href: "/specialties" }
      ]
    },
    {
      title: "For Therapists",
      links: [
        { label: "Join TherapyList", href: "/join" },
        { label: "Therapist Login", href: "/login" },
        { label: "Resources", href: "/blog" }
      ]
    },
    {
      title: "Company",
      links: [
        { label: "About Us", href: "/about" },
        { label: "Blog", href: "/blog" },
        { label: "Contact", href: "/contact" },
        { label: "Privacy Policy", href: "/privacy" },
        { label: "Terms of Service", href: "/terms" }
      ]
    }
  ];

  return (
    <footer className="bg-[#254e70] text-white relative">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#9dacff] via-white to-[#9dacff]"></div>
      
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Main footer content */}
          <div className="grid md:grid-cols-4 gap-6 lg:gap-8 mb-6">
            {/* Brand section - takes up more space */}
            <div className="md:col-span-1">
              <div className="mb-4">
                <img 
                  src="http://cms.therapylist.com/wp-content/uploads/2025/07/TherapyList-Logo-Updated.svg" 
                  alt="TherapyList Logo" 
                  className="h-12 w-auto"
                />
              </div>
              <p className="text-white/80 leading-relaxed mb-4 max-w-sm text-sm">
                Connecting people with qualified mental health professionals. Your journey to better mental health starts here.
              </p>
              
              {/* CTA Button */}
              <a href="/find-therapists" className="inline-flex items-center gap-2 bg-[#9dacff] text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-[#254e70] transition-all duration-200">
                Find Your Therapist
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
            
            {/* Links sections */}
            {footerSections.map((section, index) => (
              <div key={index}>
                <h3 className="text-lg font-medium text-white mb-3">
                  {section.title}
                </h3>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a 
                        href={link.href} 
                        className="text-white/70 hover:text-[#9dacff] transition-colors duration-200 text-sm"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Trust indicators */}
          <div className="border-t border-white/20 pt-6 mb-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
              <div>
                <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-4 h-4 text-[#9dacff]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div className="text-xs text-white/70">Multiple Specialties</div>
              </div>
              <div>
                <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-4 h-4 text-[#9dacff]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div className="text-xs text-white/70">Licensed Only</div>
              </div>
              <div>
                <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-4 h-4 text-[#9dacff]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
                <div className="text-xs text-white/70">Insurance Friendly</div>
              </div>
              <div>
                <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                  <svg className="w-4 h-4 text-[#9dacff]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="text-xs text-white/70">Video & In-Person</div>
              </div>
            </div>
          </div>

          {/* Bottom section */}
          <div className="border-t border-white/20 pt-4 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/70 text-xs">
              © {new Date().getFullYear()} TherapyList. All rights reserved.
            </p>
            
            {/* Social links */}
            <div className="flex items-center gap-3">
              <span className="text-white/70 text-xs">Follow us:</span>
              <div className="flex gap-2">
                {/* Facebook */}
                <button type="button" aria-label="Facebook" className="w-7 h-7 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#9dacff] transition-colors duration-200">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </button>

                {/* Twitter */}
                <button type="button" aria-label="Twitter" className="w-7 h-7 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#9dacff] transition-colors duration-200">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </button>

                {/* LinkedIn */}
                <button type="button" aria-label="LinkedIn" className="w-7 h-7 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#9dacff] transition-colors duration-200">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterMain; 